(function () {
  var header = document.querySelector("[data-site-header]");
  var toggle = document.querySelector("[data-mobile-toggle]");

  var blackFridayBar = document.querySelector("[data-black-friday-bar]");
  var blackFridayCountdown = document.querySelector("[data-black-friday-countdown]");
  var campaignCards = Array.from(document.querySelectorAll("[data-black-friday-card]")).map(function (element) {
    return {
      element: element,
      hours: element.querySelector("[data-campaign-hours]"),
      minutes: element.querySelector("[data-campaign-minutes]"),
      seconds: element.querySelector("[data-campaign-seconds]")
    };
  });
  if ((blackFridayBar && blackFridayCountdown) || campaignCards.length) {
    var blackFridayStart = Date.parse("2026-11-27T00:00:00-03:00");
    var countdownInterval;

    function updateBlackFridayCountdown() {
      var remaining = blackFridayStart - Date.now();
      if (remaining <= 0) {
        if (blackFridayBar) blackFridayBar.hidden = true;
        campaignCards.forEach(function (card) { card.element.hidden = true; });
        window.clearInterval(countdownInterval);
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      var twoDigits = function (value) { return String(value).padStart(2, "0"); };

      if (blackFridayCountdown) blackFridayCountdown.textContent = days + "d " + twoDigits(hours) + "h " + twoDigits(minutes) + "m " + twoDigits(seconds) + "s";
      if (blackFridayBar) blackFridayBar.hidden = false;
      campaignCards.forEach(function (card) {
        card.hours.textContent = twoDigits(Math.floor(totalSeconds / 3600));
        card.minutes.textContent = twoDigits(minutes);
        card.seconds.textContent = twoDigits(seconds);
        card.element.hidden = false;
      });
    }

    updateBlackFridayCountdown();
    if (blackFridayStart > Date.now()) {
      countdownInterval = window.setInterval(updateBlackFridayCountdown, 1000);
    }
  }

  if (header && toggle) {
    toggle.addEventListener("click", function () {
      var isOpen = header.getAttribute("data-mobile-open") === "true";
      header.setAttribute("data-mobile-open", isOpen ? "false" : "true");
      toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
    });
  }

  document.querySelectorAll("[data-collection-sort-select]").forEach(function (select) {
    select.addEventListener("change", function () {
      if (select.form) select.form.submit();
    });
  });

  document.querySelectorAll("[data-cart-quantity]").forEach(function (quantityControl) {
    var input = quantityControl.querySelector("[data-cart-quantity-input]");
    var minus = quantityControl.querySelector("[data-cart-quantity-minus]");
    var plus = quantityControl.querySelector("[data-cart-quantity-plus]");

    function changeQuantity(delta) {
      if (!input) return;
      var current = parseInt(input.value, 10);
      var next = (Number.isFinite(current) ? current : 1) + delta;
      input.value = Math.max(0, next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (minus) {
      minus.addEventListener("click", function () {
        changeQuantity(-1);
      });
    }

    if (plus) {
      plus.addEventListener("click", function () {
        changeQuantity(1);
      });
    }
  });

  var productForms = document.querySelectorAll(".product-form");

  productForms.forEach(function (form) {
    var select = form.querySelector("[data-variant-select]");
    var radios = form.querySelectorAll("[data-variant-radio]");
    var variantInput = form.querySelector("[data-variant-id-input]");
    var price = document.querySelector("[data-product-price]");
    var promotion = document.querySelector("[data-product-promotion]");
    var comparePrice = document.querySelector("[data-product-compare-price]");
    var discountLabel = document.querySelector("[data-product-discount]");
    var sku = document.querySelector("[data-product-sku]");
    var installment = document.querySelector("[data-product-installment]");
    var submit = form.querySelector("[data-product-submit]");
    var quantityInput = form.querySelector("[data-quantity-input]");
    var quantityMinus = form.querySelector("[data-quantity-minus]");
    var quantityPlus = form.querySelector("[data-quantity-plus]");
    var shippingForm = document.querySelector("[data-shipping-form]");
    var shippingResult = document.querySelector("[data-shipping-result]");
    var freeShippingMeter = document.querySelector("[data-free-shipping-meter]");
    var freeShippingText = document.querySelector("[data-free-shipping-text]");
    var freeShippingFill = document.querySelector("[data-free-shipping-fill]");

    function formatMoneyFromCents(cents) {
      return (Math.max(0, cents) / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }

    function updateFreeShipping(priceCents) {
      if (!freeShippingMeter || !freeShippingText || !freeShippingFill || !Number.isFinite(priceCents)) return;

      var threshold = parseInt(freeShippingMeter.dataset.freeShippingThreshold, 10);
      if (!Number.isFinite(threshold) || threshold <= 0) return;

      var remaining = threshold - priceCents;
      var progress = Math.min(100, Math.max(0, (priceCents / threshold) * 100));
      freeShippingFill.style.width = progress + "%";

      if (remaining > 0) {
        freeShippingText.innerHTML = "Aproveite: faltam <strong>" + formatMoneyFromCents(remaining) + "</strong> para ganhar <strong>frete grátis</strong>.";
      } else {
        freeShippingText.innerHTML = "Este produto já libera <strong>frete grátis</strong> na sua compra.";
      }
    }

    function updateVariant(option) {
      if (!option) return;

      if (variantInput && option.value) variantInput.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (promotion && comparePrice && discountLabel) {
        var regularCents = Number(option.dataset.comparePriceCents || 0);
        var saleCents = Number(option.dataset.priceCents || 0);
        promotion.hidden = !(regularCents > saleCents);
        comparePrice.textContent = option.dataset.comparePrice || "";
        discountLabel.textContent = regularCents > saleCents ? Math.round((regularCents - saleCents) * 100 / regularCents) + "% OFF" : "";
      }
      if (sku && option.dataset.sku) sku.textContent = option.dataset.sku;
      if (installment && option.dataset.installment) installment.textContent = option.dataset.installment;
      if (option.dataset.priceCents) updateFreeShipping(parseInt(option.dataset.priceCents, 10));
      form.dataset.variantTitle = option.dataset.variantTitle || option.value || "";
      form.dataset.variantPrice = option.dataset.price || "";

      if (submit) {
        var isAvailable = option.dataset.available !== "false" && !option.disabled;
        submit.disabled = !isAvailable;
        submit.textContent = isAvailable ? "Adicionar à sacola" : "Indisponível";
      }

      form.querySelectorAll("[data-direct-checkout]").forEach(function (button) {
        var isAvailable = option.dataset.available !== "false" && !option.disabled;
        button.disabled = !isAvailable;
        button.textContent = isAvailable ? "Comprar agora" : "Indisponível";
      });
    }

    if (select) {
      select.addEventListener("change", function () {
        updateVariant(select.options[select.selectedIndex]);
      });
    }

    if (radios.length) {
      radios.forEach(function (radio) {
        radio.addEventListener("change", function () {
          if (radio.checked) updateVariant(radio);
        });
      });
    }

    function changeQuantity(delta) {
      if (!quantityInput) return;
      var current = parseInt(quantityInput.value, 10);
      var next = (Number.isFinite(current) ? current : 1) + delta;
      quantityInput.value = Math.max(1, next);
    }

    if (quantityMinus) {
      quantityMinus.addEventListener("click", function () {
        changeQuantity(-1);
      });
    }

    if (quantityPlus) {
      quantityPlus.addEventListener("click", function () {
        changeQuantity(1);
      });
    }

    if (shippingForm && shippingResult) {
      shippingForm.addEventListener("submit", function (event) {
        event.preventDefault();
        shippingResult.hidden = false;
      });
    }
  });

  var addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  var cartNotification = document.querySelector("[data-cart-notification]");
  var cartNotificationClose = document.querySelector("[data-cart-notification-close]");
  var cartNotificationImage = document.querySelector("[data-cart-notification-image]");
  var cartNotificationTitle = document.querySelector("[data-cart-notification-title]");
  var cartNotificationVariant = document.querySelector("[data-cart-notification-variant]");
  var cartNotificationCount = document.querySelector("[data-cart-notification-count]");
  var cartNotificationTotal = document.querySelector("[data-cart-notification-total]");
  var cartCounts = document.querySelectorAll("[data-cart-count]");
  var cartDrawer = document.querySelector("[data-cart-drawer]");
  var cartDrawerItems = document.querySelector("[data-cart-drawer-items]");
  var cartDrawerFooter = document.querySelector("[data-cart-drawer-footer]");
  var cartDrawerTriggers = document.querySelectorAll("[data-cart-drawer-trigger]");
  var cartDrawerCloseButtons = document.querySelectorAll("[data-cart-drawer-close]");
  var cartDrawerCloseTimer;
  var lastCartDrawerTrigger;
  var freeShippingThreshold = 39900;
  var notificationTimer;

  function formatCartMoney(cents) {
    return (Math.max(0, Number(cents) || 0) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function cartEndpoint(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    return root.replace(/\/$/, "") + path;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      }[character];
    });
  }

  function updateCartCounts(cart) {
    if (!cart) return;

    cartCounts.forEach(function (count) {
      count.textContent = cart.item_count;
    });

    cartDrawerTriggers.forEach(function (trigger) {
      trigger.setAttribute("aria-label", "Sacola com " + cart.item_count + (cart.item_count === 1 ? " item" : " itens"));
    });
  }

  function setCartDrawerLoading() {
    if (!cartDrawerItems) return;
    cartDrawerItems.innerHTML = '<div class="cart-drawer__empty">Carregando sacola...</div>';
    if (cartDrawerFooter) cartDrawerFooter.innerHTML = "";
  }

  function setCartDrawerError() {
    if (!cartDrawerItems) return;
    cartDrawerItems.innerHTML = '<div class="cart-drawer__empty cart-drawer__error">Não foi possível carregar sua sacola agora. Tente novamente.</div>';
    if (cartDrawerFooter) cartDrawerFooter.innerHTML = "";
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer || !cartDrawerItems || !cartDrawerFooter || !cart) return;

    updateCartCounts(cart);

    if (!cart.items || !cart.items.length) {
      cartDrawerItems.innerHTML = [
        '<div class="cart-drawer__empty">',
        "<p>Sua sacola está vazia.</p>",
        '<a class="button" href="' + cartEndpoint("/collections/all") + '">Continuar comprando</a>',
        "</div>",
      ].join("");
      cartDrawerFooter.innerHTML = "";
      return;
    }

    cartDrawerItems.innerHTML = cart.items
      .map(function (item) {
        var variantTitle = item.variant_title && item.variant_title !== "Default Title" ? '<span class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + "</span>" : "";
        var imageHtml = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
          : '<div class="cart-drawer__image-placeholder" aria-hidden="true"></div>';

        return [
          '<article class="cart-drawer__item" data-cart-drawer-line="' + escapeHtml(item.key) + '">',
          imageHtml,
          '<div class="cart-drawer__item-main">',
          '<a class="cart-drawer__item-title" href="' + escapeHtml(item.url || "#") + '">' + escapeHtml(item.product_title) + variantTitle + "</a>",
          '<div class="cart-drawer__quantity" aria-label="Quantidade">',
          '<button type="button" aria-label="Diminuir quantidade" data-cart-drawer-change="-1" data-line-key="' + escapeHtml(item.key) + '">&minus;</button>',
          '<input type="number" min="0" value="' + item.quantity + '" aria-label="Quantidade de ' + escapeHtml(item.product_title) + '" data-cart-drawer-quantity-input data-line-key="' + escapeHtml(item.key) + '">',
          '<button type="button" aria-label="Aumentar quantidade" data-cart-drawer-change="1" data-line-key="' + escapeHtml(item.key) + '">+</button>',
          "</div>",
          "</div>",
          '<div class="cart-drawer__item-side">',
          '<button class="cart-drawer__remove" type="button" aria-label="Remover ' + escapeHtml(item.product_title) + '" data-cart-drawer-remove data-line-key="' + escapeHtml(item.key) + '">',
          '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 7h16"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M6 7l1 14h10l1-14"></path><path d="M9 7V4h6v3"></path></svg>',
          "</button>",
          '<strong class="cart-drawer__price">' + formatCartMoney(item.final_line_price) + "</strong>",
          "</div>",
          "</article>",
        ].join("");
      })
      .join("");

    var remaining = freeShippingThreshold - cart.total_price;
    var progress = Math.min(100, Math.max(0, (cart.total_price / freeShippingThreshold) * 100));
    var shippingText =
      remaining > 0
        ? 'Adicione mais <strong>' + formatCartMoney(remaining) + '</strong> ao seu pedido e <strong>ganhe frete grátis</strong>'
        : '<strong>Frete grátis liberado</strong> para seu pedido';

    cartDrawerFooter.innerHTML = [
      '<div class="cart-drawer__shipping-meter">',
      '<div class="cart-drawer__shipping-bar" style="--cart-progress: ' + progress + '%"><span style="width: ' + progress + '%"></span><span class="cart-drawer__shipping-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M3 7h11v10H3z"></path><path d="M14 10h4l3 3v4h-7z"></path><circle cx="7" cy="18" r="2"></circle><circle cx="18" cy="18" r="2"></circle></svg></span></div>',
      "<p>" + shippingText + "</p>",
      "</div>",
      '<div class="cart-drawer__shipping-panel">',
      '<div class="cart-drawer__shipping-title"><span>Meios de envio</span><span>&minus;</span></div>',
      '<p class="cart-drawer__shipping-note">No próximo passo você informa o endereço, escolhe o frete e paga com segurança.</p>',
      "</div>",
      '<div class="cart-drawer__subtotal"><span>Subtotal</span><strong>' + formatCartMoney(cart.total_price) + "</strong></div>",
      '<a class="button cart-drawer__checkout" href="' + cartEndpoint("/checkout") + '">Ir para pagamento</a>',
      '<a class="cart-drawer__continue" href="' + cartEndpoint("/collections/all") + '">Continuar comprando</a>',
    ].join("");
  }

  function fetchCart() {
    return fetch(cartEndpoint("/cart.js"), {
      headers: {
        Accept: "application/json",
      },
    }).then(function (response) {
      if (!response.ok) throw new Error("cart fetch failed");
      return response.json();
    });
  }

  function openCartDrawer(trigger, cart) {
    if (!cartDrawer) return;

    if (trigger) lastCartDrawerTrigger = trigger;
    window.clearTimeout(cartDrawerCloseTimer);
    cartDrawer.hidden = false;
    cartDrawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-open");
    window.requestAnimationFrame(function () {
      cartDrawer.classList.add("is-open");
    });

    var closeButton = cartDrawer.querySelector(".cart-drawer__close");
    if (closeButton) {
      window.setTimeout(function () {
        closeButton.focus();
      }, 80);
    }

    if (cart) {
      renderCartDrawer(cart);
      return;
    }

    setCartDrawerLoading();
    fetchCart().then(renderCartDrawer).catch(setCartDrawerError);
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;

    cartDrawer.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-open");

    window.clearTimeout(cartDrawerCloseTimer);
    cartDrawerCloseTimer = window.setTimeout(function () {
      if (!cartDrawer.classList.contains("is-open")) cartDrawer.hidden = true;
    }, 240);

    if (lastCartDrawerTrigger && document.contains(lastCartDrawerTrigger)) {
      lastCartDrawerTrigger.focus();
    }
  }

  function changeCartLine(key, quantity) {
    if (!key) return Promise.resolve();
    if (cartDrawer) cartDrawer.setAttribute("aria-busy", "true");

    return fetch(cartEndpoint("/cart/change.js"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, Number(quantity) || 0),
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart change failed");
        return response.json();
      })
      .then(renderCartDrawer)
      .catch(setCartDrawerError)
      .finally(function () {
        if (cartDrawer) cartDrawer.setAttribute("aria-busy", "false");
      });
  }

  function cartDrawerQuantityInputForKey(key) {
    if (!cartDrawer) return null;
    var inputs = cartDrawer.querySelectorAll("[data-cart-drawer-quantity-input]");

    for (var index = 0; index < inputs.length; index += 1) {
      if (inputs[index].dataset.lineKey === key) return inputs[index];
    }

    return null;
  }

  function formProductTitle(form, item) {
    if (form.dataset.productTitle) return form.dataset.productTitle;
    if (item && item.product_title) return item.product_title;
    var cardTitle = form.closest(".product-card") && form.closest(".product-card").querySelector("h3");
    var pageTitle = document.querySelector(".product-main h1");
    return (cardTitle || pageTitle || {}).textContent || "Produto";
  }

  function formProductUrl(form, item) {
    if (form.dataset.productUrl) return form.dataset.productUrl;
    if (item && item.url) return item.url;
    var cardLink = form.closest(".product-card") && form.closest(".product-card").querySelector("a[href]");
    return cardLink ? cardLink.href : window.location.href;
  }

  function formProductImage(form, item) {
    if (form.dataset.productImage) return form.dataset.productImage;
    if (item && item.image) return item.image;
    var cardImage = form.closest(".product-card") && form.closest(".product-card").querySelector("img");
    var pageImage = document.querySelector(".product-main__image img");
    return (cardImage || pageImage || {}).currentSrc || (cardImage || pageImage || {}).src || "";
  }

  function formVariantSummary(form, item) {
    var variantTitle = form.dataset.variantTitle || "";
    var checkedVariant = form.querySelector("[data-variant-radio]:checked");
    if (checkedVariant) variantTitle = checkedVariant.dataset.variantTitle || checkedVariant.nextElementSibling && checkedVariant.nextElementSibling.textContent || variantTitle;
    if (!variantTitle && item && item.variant_title && item.variant_title !== "Default Title") variantTitle = item.variant_title;
    if (variantTitle === "Default Title") variantTitle = "";

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

    var price = form.dataset.variantPrice || (item && item.final_price ? formatCartMoney(item.final_price) : "");
    var parts = [];
    if (variantTitle) parts.push(variantTitle);
    if (price) parts.push(quantity + "x " + price);
    return parts.join(" · ");
  }

  function showCartNotification(form, item, cart) {
    if (!cartNotification) return;

    var image = formProductImage(form, item);
    if (cartNotificationImage) {
      if (image) {
        cartNotificationImage.src = image;
        cartNotificationImage.alt = formProductTitle(form, item);
        cartNotificationImage.hidden = false;
      } else {
        cartNotificationImage.hidden = true;
      }
    }

    if (cartNotificationTitle) {
      cartNotificationTitle.textContent = formProductTitle(form, item);
      cartNotificationTitle.href = formProductUrl(form, item);
    }

    if (cartNotificationVariant) cartNotificationVariant.textContent = formVariantSummary(form, item);
    if (cartNotificationCount) cartNotificationCount.textContent = "Total (" + cart.item_count + (cart.item_count === 1 ? " produto" : " produtos") + "):";
    if (cartNotificationTotal) cartNotificationTotal.textContent = formatCartMoney(cart.total_price);

    updateCartCounts(cart);

    cartNotification.hidden = false;
    window.clearTimeout(notificationTimer);
    notificationTimer = window.setTimeout(function () {
      cartNotification.hidden = true;
    }, 7000);
  }

  if (cartNotificationClose && cartNotification) {
    cartNotificationClose.addEventListener("click", function () {
      cartNotification.hidden = true;
      window.clearTimeout(notificationTimer);
    });
  }

  cartDrawerTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openCartDrawer(trigger);
    });
  });

  cartDrawerCloseButtons.forEach(function (button) {
    button.addEventListener("click", closeCartDrawer);
  });

  if (cartDrawer) {
    cartDrawer.addEventListener("click", function (event) {
      var quantityButton = event.target.closest("[data-cart-drawer-change]");
      var removeButton = event.target.closest("[data-cart-drawer-remove]");

      if (quantityButton) {
        var input = cartDrawerQuantityInputForKey(quantityButton.dataset.lineKey);
        var current = input ? parseInt(input.value, 10) : 1;
        var next = (Number.isFinite(current) ? current : 1) + parseInt(quantityButton.dataset.cartDrawerChange, 10);
        changeCartLine(quantityButton.dataset.lineKey, next);
      }

      if (removeButton) {
        changeCartLine(removeButton.dataset.lineKey, 0);
      }
    });

    cartDrawer.addEventListener("change", function (event) {
      var input = event.target.closest("[data-cart-drawer-quantity-input]");
      if (!input) return;

      var quantity = parseInt(input.value, 10);
      changeCartLine(input.dataset.lineKey, Number.isFinite(quantity) ? quantity : 1);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && cartDrawer.classList.contains("is-open")) {
        closeCartDrawer();
      }
    });
  }

  addToCartForms.forEach(function (form) {
    form.addEventListener("submit", function (event) {
      var submit = event.submitter && event.submitter.matches('button[type="submit"]') ? event.submitter : form.querySelector('button[type="submit"]');
      var directCheckout = submit && submit.hasAttribute("data-direct-checkout");
      if (!window.fetch || (submit && submit.disabled)) return;

      event.preventDefault();
      var formButtons = form.querySelectorAll('button[type="submit"]');
      formButtons.forEach(function (button) {
        button.classList.add("is-loading");
        button.disabled = true;
      });

      fetch(cartEndpoint("/cart/add.js"), {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: new FormData(form),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("cart add failed");
          return response.json();
        })
        .then(function (item) {
          if (directCheckout) {
            window.location.href = cartEndpoint("/checkout");
            return null;
          }

          return fetch(cartEndpoint("/cart.js"), {
            headers: {
              Accept: "application/json",
            },
          }).then(function (response) {
            if (!response.ok) throw new Error("cart fetch failed");
            return response.json().then(function (cart) {
              if (cartDrawer) {
                if (cartNotification) cartNotification.hidden = true;
                window.clearTimeout(notificationTimer);
                openCartDrawer(submit || form, cart);
              } else {
                showCartNotification(form, item, cart);
              }
            });
          });
        })
        .catch(function () {
          if (cartNotificationTitle && cartNotification) {
            cartNotificationTitle.textContent = "Não foi possível adicionar agora. Tente novamente.";
            cartNotificationTitle.removeAttribute("href");
            cartNotification.hidden = false;
          }
        })
        .finally(function () {
          formButtons.forEach(function (button) {
            button.classList.remove("is-loading");
            button.disabled = false;
          });
        });
    });
  });
})();
